import React from 'react'
import PropTypes from 'prop-types'

import Dropdown from '../../components/Dropdown'
import withUser from '../Login/withUser'

function ProfileDropdown({ user, ...props }) {
  const [name] = user.username.split('@')
  return (
    <Dropdown
      button={name}
      {...props}
    />
  )
}

Dropdown.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired
  })
}

export default withUser()(ProfileDropdown)
